import React, { useEffect, useState } from 'react';
import OnboardingPage from './onboarding'; // Import the desktop view
import OnboardingMobilePage from './onboardingMobileview'; // Import the mobile view
import { useMediaQuery } from '@mui/material';
import PropTypes from 'prop-types';
import { getHiringDetails } from '../fetchUserInfo';
import { formatQueryDate } from '../../../Utils/formatDate';

const Onboarding = ({ employee, organizationDetails, totalExperience }) => {
  const isMobile = useMediaQuery('(max-width:768px)');
  const [isMobileView, setIsMobileView] = useState(isMobile);
  const [loading, setLoading] = useState(false);
  const [hiringDetails, setHiringDetails] = useState([]);

  useEffect(() => {
    setIsMobileView(isMobile);
  }, [isMobile]);


  const fetchEmployeeHiringDetails = async (fromDate, toDate, emailId, mobile) => {
    setLoading(true);
    try {
      const response = await getHiringDetails(
        fromDate,
        toDate,
        emailId,
        mobile,
      );

      if (response.status === 500) {
        throw new Error('Something went wrong');
      } else if (response.status === 404) {
        throw new Error('Interview details not found');
      }

      setHiringDetails(response?.data);

    } catch (error) {
      setHiringDetails([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const fromDate = formatQueryDate(employee?.dateofjoining, 'fromDate');
    const toDate = formatQueryDate(employee?.dateofjoining, 'toDate');
    fetchEmployeeHiringDetails(fromDate, toDate, employee?.emailId, employee?.mobile);
  }, [employee?.mobile]);

  return isMobileView ? (
    <OnboardingMobilePage
      organizationDetails={organizationDetails}
      totalExperience={totalExperience}
      loading={loading}
      hiringDetails={hiringDetails}
    />
  ) : (
    <OnboardingPage
      organizationDetails={organizationDetails}
      totalExperience={totalExperience}
      loading={loading}
      hiringDetails={hiringDetails}
    />
  );
};
Onboarding.propTypes = {
  organizationDetails: PropTypes.arrayOf(PropTypes.object).isRequired,
  totalExperience: PropTypes.arrayOf(PropTypes.object).isRequired,
  employee: PropTypes.object.isRequired,
};
export default Onboarding;
